import { navigationRef } from "."
import { RootStackParamList } from "../../types"

/** Allows navigating from anywhere  */
export function navigateMainNavigator<Route extends keyof RootStackParamList>(name: Route, params: RootStackParamList[Route]) {
  if (navigationRef.isReady()) {
    navigationRef.navigate(name, params)
  }
}
